<!-- Page Header (oculto no modo embutido: já há o cabeçalho da aba) -->
<div class="page-header" *ngIf="!embutido">
  <div class="header-icon">
    <i class="pi pi-truck"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- TabView: Cadastro e Lista -->
<div class="tabs-container" [class.embutido]="embutido">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 1: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-user-plus tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Grid de Cards -->
      <div class="cards-container">
        <!-- Coluna Esquerda -->
        <div class="column-left">
          <!-- Card: Identificacao -->
          <div class="form-card" [class.editing]="!!form.id">
            <div class="editing-banner" *ngIf="form.id">
              <i class="pi pi-pencil"></i>
              <span>{{ texts.titulo_editar }}</span>
            </div>
            <div class="card-header">
              <div class="card-header-icon">
                <i class="pi pi-id-card"></i>
              </div>
              <span class="card-header-title">{{ texts.identificacao }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Tipo Pessoa (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.tipo_pessoa }} <span class="required" *ngIf="!form.tipoPessoa">*</span></label>
                  <p-dropdown id="tipoPessoa" [options]="tipoPessoaOptions"
                    [(ngModel)]="form.tipoPessoa" optionLabel="label" styleClass="w-full"
                    [placeholder]="placeholders.tipo_pessoa" appendTo="body"
                    [class.error-field]="isFormSubmitted && !form.tipoPessoa"
                    (onChange)="onTipoPessoaChange()">
                  </p-dropdown>
                </div>
                <!-- CI (half) - apenas Pessoa Fisica -->
                <div class="form-field half" *ngIf="form.tipoPessoa?.value === 'FISICA'">
                  <label class="form-label">{{ labels.ci }}</label>
                  <input type="text" pInputText [(ngModel)]="form.ci"
                    [placeholder]="placeholders.ci" class="w-full"
                    (input)="onCiInput($event)" />
                </div>
                <!-- RUC com busca automatica (cadastro novo) -->
                <div class="form-field half" *ngIf="form.tipoPessoa?.value === 'JURIDICA' && !form.id">
                  <app-ruc-busca
                    #rucBuscaRef
                    [showLabel]="true"
                    [label]="labels.ruc"
                    [placeholder]="placeholders.ruc"
                    (pessoaConfirmada)="onRucPessoaConfirmada($event)"
                    (pessoaVinculada)="onRucPessoaVinculada($event)"
                    (rucValueChange)="form.ruc = $event"
                    (rucLimpo)="onRucLimpo()">
                  </app-ruc-busca>
                </div>
                <!-- RUC simples (edicao) -->
                <div class="form-field half" *ngIf="form.tipoPessoa?.value === 'JURIDICA' && form.id">
                  <label class="form-label">{{ labels.ruc }}</label>
                  <input type="text" pInputText [(ngModel)]="form.ruc"
                    [placeholder]="placeholders.ruc" class="w-full" inputmode="tel"
                    [class.ng-invalid]="avisoRucEdicao"
                    [class.ng-dirty]="avisoRucEdicao"
                    (input)="onRucEdicaoInput($event)" />
                  <small *ngIf="avisoRucEdicao" class="p-error">{{ avisoRucEdicao }}</small>
                </div>
                <!-- Nome (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.nome }} <span class="required" *ngIf="!form.nome">*</span></label>
                  <input type="text" pInputText [(ngModel)]="form.nome"
                    [placeholder]="placeholders.nome" class="w-full"
                    [class.error-field]="isFormSubmitted && !form.nome"
                    (blur)="onNomeBlur()" />
                </div>
                <!-- Nome Fantasia (full) - apenas Pessoa Juridica -->
                <div class="form-field full" *ngIf="!isPessoaFisica()">
                  <label class="form-label">{{ labels.nome_fantasia }}</label>
                  <input type="text" pInputText [(ngModel)]="form.fantasia"
                    [placeholder]="placeholders.nome_fantasia" class="w-full" />
                </div>
                <!-- Tipo Natureza Fiscal (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.tipo_natureza_fiscal }} <span class="required" *ngIf="!form.tipoNaturezaFiscal">*</span></label>
                  <p-dropdown id="tipoNaturezaFiscal" [options]="tipoNaturezaFiscalOptions"
                    [(ngModel)]="form.tipoNaturezaFiscal" optionLabel="label" styleClass="w-full"
                    [placeholder]="placeholders.tipo_natureza_fiscal" appendTo="body"
                    [class.error-field]="isFormSubmitted && !form.tipoNaturezaFiscal">
                  </p-dropdown>
                </div>
                <!-- Categoria (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.categoria }}</label>
                  <div class="checkbox-group">
                    <div class="checkbox-item">
                      <p-checkbox inputId="categoriaFornecedor" name="categoriaFornecedor"
                        [(ngModel)]="form.categoriaFornecedor" [binary]="true" />
                      <label for="categoriaFornecedor">{{ labels.provedor }}</label>
                    </div>
                    <div class="checkbox-item">
                      <p-checkbox inputId="categoriaCliente" name="categoriaCliente"
                        [(ngModel)]="form.categoriaCliente" [binary]="true" />
                      <label for="categoriaCliente">{{ labels.cliente }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Coluna Direita -->
        <div class="column-right">
          <!-- Card: Contato -->
          <div class="form-card" [class.editing]="!!form.id">
            <div class="card-header">
              <div class="card-header-icon contact-icon">
                <i class="pi pi-phone"></i>
              </div>
              <span class="card-header-title">{{ texts.contato }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- DDI / Telefone (full) -->
                <div class="form-field full">
                  <app-phone-input
                    [(telefone)]="form.telefone"
                    [(ddi)]="paisSelecionado"
                    [label]="labels.ddi + ' / ' + labels.telefone"
                    [placeholder]="placeholders.telefone">
                  </app-phone-input>
                </div>
                <!-- E-mail (full) -->
                <div class="form-field full">
                  <label class="form-label">{{ labels.email }}</label>
                  <input type="email" pInputText [(ngModel)]="form.email"
                    [placeholder]="placeholders.email" class="w-full" />
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Endereco -->
          <div class="form-card" [class.editing]="!!form.id">
            <div class="card-header">
              <div class="card-header-icon address-icon">
                <i class="pi pi-map-marker"></i>
              </div>
              <span class="card-header-title">{{ texts.endereco }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Cidade (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.cidade }}</label>
                  <p-dropdown id="selecionarCidade" [options]="cidadeList"
                    [(ngModel)]="form.cidade" optionLabel="label" dataKey="value"
                    [placeholder]="placeholders.cidade" [filter]="true" filterBy="label"
                    [showClear]="true" (onChange)="onSelecionarCidade($event)"
                    styleClass="w-full" appendTo="body" panelStyleClass="ddi-dropdown-panel-erp"
                    scrollHeight="340px">
                  </p-dropdown>
                </div>
                <!-- Estado (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.estado }}</label>
                  <input type="text" pInputText class="w-full input-field-disabled"
                    [disabled]="true" [(ngModel)]="estadoCidade" />
                </div>
                <!-- Endereco (two-thirds) -->
                <div class="form-field two-thirds">
                  <label class="form-label">{{ labels.endereco }}</label>
                  <input type="text" pInputText [(ngModel)]="form.endereco"
                    [placeholder]="placeholders.endereco" class="w-full" />
                </div>
                <!-- Numero (third) -->
                <div class="form-field third">
                  <label class="form-label">{{ labels.numero }}</label>
                  <input type="text" pInputText [(ngModel)]="form.numero"
                    [placeholder]="placeholders.numero" class="w-full" />
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Dados Pessoais (apenas Pessoa Física) -->
          <div class="form-card" [class.editing]="!!form.id" *ngIf="isPessoaFisica()">
            <div class="card-header">
              <div class="card-header-icon personal-icon">
                <i class="pi pi-user"></i>
              </div>
              <span class="card-header-title">{{ texts.dados_pessoais }}</span>
            </div>
            <div class="card-content">
              <div class="form-grid">
                <!-- Data Nascimento (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.data_nascimento }}</label>
                  <p-inputMask [(ngModel)]="form.dataNascimento"
                    mask="99/99/9999"
                    placeholder="dd/mm/aaaa"
                    slotChar="dd/mm/aaaa"
                    styleClass="w-full"></p-inputMask>
                </div>
                <!-- Sexo (half) -->
                <div class="form-field half">
                  <label class="form-label">{{ labels.sexo }} <span class="required" *ngIf="!form.sexo">*</span></label>
                  <p-dropdown id="sexo" [options]="sexoOptions"
                    [(ngModel)]="form.sexo" optionLabel="label" styleClass="w-full"
                    [placeholder]="placeholders.sexo" appendTo="body"
                    [class.error-field]="isFormSubmitted && !form.sexo">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <button *ngIf="form.id" pButton [label]="botoes.limpar"
          severity="secondary" icon="pi pi-eraser"
          (click)="limparFormulario()" class="btn-secondary">
        </button>
        <button *ngIf="!form.id" pButton [label]="botoes.salvar"
          icon="pi pi-check" (click)="submit()" class="btn-primary">
        </button>
        <button *ngIf="form.id" pButton [label]="botoes.atualizar"
          icon="pi pi-check" (click)="submit()" class="btn-primary">
        </button>
      </div>
    </p-tabPanel>

    <!-- Aba 2: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <!-- Card: Lista de Fornecedores -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.lista_de_fornecedores }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.novo_fornecedor"
              icon="pi pi-plus" (click)="novoFornecedor()" class="btn-primary btn-sm">
            </button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.pesquisar"
                [(ngModel)]="searchNome"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="pessoas" [loading]="loading"
            (onSort)="onSortChange($event)"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('codigoPessoa')" pSortableColumn="codigoPessoa" style="width: 5%">
                  {{ labels.codigo_fornecedor }}<p-sortIcon [field]="'codigoPessoa'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 18%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('fantasia')" pSortableColumn="fantasia" style="width: 15%">
                  {{ labels.nome_fantasia }}<p-sortIcon [field]="'fantasia'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('telefone')" pSortableColumn="telefone" style="width: 12%">
                  {{ labels.telefone }}<p-sortIcon [field]="'telefone'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('ci')" pSortableColumn="ci" style="width: 8%">
                  {{ labels.ci }}<p-sortIcon [field]="'ci'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('ruc')" pSortableColumn="ruc" style="width: 10%">
                  {{ labels.ruc }}<p-sortIcon [field]="'ruc'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('cidade')" pSortableColumn="cidade.nome" style="width: 10%">
                  {{ labels.cidade }}<p-sortIcon [field]="'cidade.nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 14%">
                  {{ labels.data_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 10%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-pessoa>
              <tr>
                <td [hidden]="!isColumnVisible('codigoPessoa')">{{ pessoa.codigoPessoa }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ pessoa.nome }}</td>
                <td [hidden]="!isColumnVisible('fantasia')">{{ pessoa.fantasia }}</td>
                <td [hidden]="!isColumnVisible('telefone')">{{ pessoa | formatPhone }}</td>
                <td [hidden]="!isColumnVisible('ci')">{{ pessoa.ci }}</td>
                <td [hidden]="!isColumnVisible('ruc')">{{ pessoa.ruc }}</td>
                <td [hidden]="!isColumnVisible('cidade')">{{ pessoa.cidade?.nome }}</td>
                <td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(pessoa.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <!-- Desktop: botoes individuais + menu de acoes extras -->
                  <span class="actions-desktop">
                    <button pButton icon="pi pi-pencil"
                      class="p-button-text p-button-rounded p-button-sm"
                      [pTooltip]="tooltips.editar" tooltipPosition="top"
                      (click)="editarFornecedor(pessoa.id)">
                    </button>
                    <button pButton icon="pi pi-trash" *ngIf="!embutido"
                      class="p-button-text p-button-rounded p-button-sm p-button-danger"
                      [pTooltip]="tooltips.excluir" tooltipPosition="top"
                      (click)="deletarFornecedor(pessoa.id)">
                    </button>
                    <button pButton icon="pi pi-ellipsis-v" *ngIf="!embutido"
                      class="p-button-text p-button-rounded p-button-sm"
                      [pTooltip]="tooltips.mais_acoes" tooltipPosition="top"
                      (click)="toggleMenu($event, pessoa)">
                    </button>
                  </span>
                  <!-- Mobile: menu kebab unico com todas as acoes -->
                  <span class="actions-mobile">
                    <button pButton [icon]="embutido ? 'pi pi-pencil' : 'pi pi-ellipsis-v'"
                      class="p-button-text p-button-rounded p-button-sm"
                      [pTooltip]="embutido ? tooltips.editar : tooltips.mais_acoes" tooltipPosition="top"
                      (click)="embutido ? editarFornecedor(pessoa.id) : toggleMenuMobile($event, pessoa)">
                    </button>
                  </span>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_fornecedor }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange3($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first3" [rows]="rows3"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows3"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<p-toast></p-toast>
<p-menu #menuAcoes [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
<p-menu #menuAcoesMobile [popup]="true" [model]="menuItemsMobile" appendTo="body"></p-menu>

<!-- Dialog de Pessoa Ja Cadastrada -->
<p-dialog
  [(visible)]="pessoaJaCadastradaDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ pessoaJaCadastradaMensagem }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="pessoaJaCadastradaDialogVisible = false"></button>
    <button pButton [label]="botoes.atualizar" icon="pi pi-pencil"
      (click)="editarPessoaJaCadastrada()"></button>
  </ng-template>
</p-dialog>

<!-- Dialog de Confirmacao de Exclusao (Wave Pattern) -->
<p-dialog
  [(visible)]="deleteDialogVisible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>
